const professionalTheme = {
  colors: {
    //Header Image (used in Detail Poll and Report Poll and View Pledge Poll)
    'headerImage-title-color': 'white',
    'headerImage-bgColor': '#221f20',

    //Left Content Card Detail Poll
    'detailPoll-leftContent-bgColor': 'white',

    //Vote & Pledging Active Period
    'poll-period-active-bgColor': 'blue',
    'poll-period-active-shadowColor': '#8b3dfb',

    //Question Card
    'poll-questionCard-bgColor': 'black',
    'poll-questionCard-question-color': '#fff',
    'poll-questionCard-answer-color': '#fff',

    //Pledge and Vote Casting Button 
    'poll-btnPledgeCastVote-color': '#FFFF00',
    'poll-btnPledgeCastVote-borderColor': '#ff1dfc',
    'poll-btnPledgeCastVote-textColor': '#5600fb',

    //Poll Page Background Color
    'poll-page-bgColor': '#221f20',
    

    //The rest of period component
    'poll-period-title-color': '#000',
    'poll-period-color': '#221f20',
    'poll-period-active-color': '#fff',
    'poll-period-bgColor': '#bfbfbf',
    'poll-period-shadowColor': '#221f20',
    
    'poll-period-title-active-color': 'yellow',
    'poll-period-separate-bgColor': 'white',


    //Detail Poll - About This Poll
    'detailPoll-about-bgColor': '#2effe3',
    'detailPoll-about-color': '#221f20',
    'detailPoll-about-desc-color': 'black',

    //Detail Poll - Share Card
    'poll-shareCard-bgColor': 'red',
    'poll-shareCard-color': 'white',
    'poll-shareCard-btnCopy-textColor': '#fff',
    'poll-shareCard-btnCopy-bgColor': 'transparent',
    'poll-shareCard-btnCopy-borderColor': 'transparent',
    
    //The rest of Question Card
    'poll-questionCard-color': 'white',
    'poll-embedVideo-shadowLeftColor': 'magenta',
    'poll-questionCard-progressBar-draw-color': 'yellow',
    'poll-questionCard-progressBar-winner-color': 'yellow',
    'poll-questionCard-progressBar-title-color': 'white',
    'poll-questionCard-progressBar-borderColor': 'white',

    'poll-questionCard-percentBox-bgColor': 'white',
    'poll-questionCard-percentBox-color': '#221f20',
    'poll-questionCard-percentBox-shadow': '#221f20',
    'poll-questionCard-percentBox-borderColor': '#221f20',

    'poll-questionCard-numberVotes-color': 'white',

    'poll-questionCard-pollOption-color': 'white',
    'poll-questionCard-pollOption-bgColor': 'black',


    //Button mighty edit a voted
    'detailPoll-btnEditVote-color': '#29FF2E',
    'detailPoll-btnEditVote-borderColor': '#5600fb',
    'detailPoll-btnEditVote-textColor': '#5600fb',

    //Button mighty withdraw a voted
    'detailPoll-btnWithdrawVote-color': '#ff001e',
    'detailPoll-btnWithdrawVote-borderColor': '#2EFFE3',
    'detailPoll-btnWithdrawVote-textColor': '#FFFF00',

    //Button mighty hide/show result
    'detailPoll-btnResultVote-color': '#29FF2E',
    'detailPoll-btnResultVote-borderColor': '#5600fb',
    'detailPoll-btnResultVote-textColor': '#5600fb',

    //Button mighty View/Edit Poll
    'detailPoll-btnViewEditPoll-color': '#FFFF00',
    'detailPoll-btnViewEditPoll-borderColor': '#ff1dfc',
    'detailPoll-btnViewEditPoll-textColor': '#5600fb',

    //Button mighty view pledge
    'detailPoll-btnViewPledge-color': '#FFFF00',
    'detailPoll-btnViewPledge-borderColor': '#ff1dfc',
    'detailPoll-btnViewPledge-textColor': '#5600fb',

    //Notice
    'notice-bgColor': '#fff',
    'notice-shadowLeft': '#FF0707',
    'notice-shadowRight': '#108EE9',
    'notice-color': '#221F20',

    //Result card
    'poll-voteResult-status-bgColor': 'black',
    'poll-voteResult-status-color': 'white',
    'poll-voteResult-status-title-color': 'yellow',

    'detailPoll-reportLink-color': 'white',

    //Use in different page for count of votes
    'voteCount-color': '#FFFF00',
    'voteCount-bottomBorderColor': '#29FF2E',
  },
};
export default professionalTheme;
  